
























import {Component, Vue, Prop, PropSync} from 'vue-property-decorator'
import DButton from '@/components/DButton/button.vue';

import {
  DxPopup
} from 'devextreme-vue';


@Component({
  name: 'UnderDevelopMock',
  components: {
    DxPopup,
    DButton,
  }
})
export default class extends Vue {

  @PropSync('popupOptions') public localPopupOptions: any;

  created() {

  }

  beforeDestroy() {
  }


  onClose() {
    this.localPopupOptions.visible = false;
  }


}
